import { useMutation } from "@tanstack/react-query";
import { Fragment, useEffect, useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { PencilFill } from "react-bootstrap-icons";
import { getRequestByAuth } from "../../../function/helper";
import Laoding from "../../Loading";
import EditAddress from "./EditAddress";

export default function SelectRegisteredAddress({
  senderOrgetter,
  onSelect,
  onClose,
  onNewAddressClick = undefined,
}) {
  const [key, setKey] = useState("");
  const [selectToEditAddress, setSelectToEditAddress] = useState(null);

  const { mutate, isPending, data } = useMutation({
    mutationKey: ["SelectRegisteredAddress"],
    mutationFn: () =>
      getRequestByAuth(
        `/address/v1/search/${senderOrgetter ? "1" : "0"}/${key}`
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return [];
      }),
  });

  useEffect(() => {
    if (key.length < 3) {
      return;
    }

    const timeOutId = setTimeout(mutate, 1000);
    return () => clearTimeout(timeOutId);
  }, [key]);

  return (
    <Fragment>
      <Modal show className="rtl-all" size="xl" centered>
        <Modal.Header className="d-flex align-item-center justify-content-center">
          <Modal.Title>
            <span>جستجو از آدرس های ثبت شده قبلی </span>
            <span>{senderOrgetter ? "گیرنده" : "فرستنده"}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-2">
            <Form.Label>
              <p>جستجوی آدرس (حداقل سه کاراکتر الزامی است)</p>
            </Form.Label>
            <Form.Control
              type="text"
              className="mb-2"
              autoFocus
              onChange={e => setKey(e.target.value)}
            />
          </div>

          {isPending && (
            <div className="w-100">
              <Laoding />
            </div>
          )}

          {!isPending && (
            <div className="w-100 px-2">
              {data?.map(item => (
                <article
                  className="w-100 d-flex flex-wrap btn btn-light border-info align-items-center my-2  justify-content-between p-0"
                  key={item.address.id}
                >
                  <Col
                    xs={12}
                    lg={senderOrgetter ? 9 : 12}
                    xl={senderOrgetter ? 10 : 12}
                    className={`${
                      senderOrgetter === 0 ? "py-3" : "py-1"
                    } pe-2 align-self-stretch d-flex flex-column justify-content-center`}
                    onClick={() => onSelect(item.address)}
                  >
                    <p className="mb-0">
                      <span>{item.address.country_name.faName} </span>
                      <span>{item.address.province_name.faName} </span>
                      <strong>{item.address.city_name.faName} </strong>
                      <span>{item.address.name} </span>
                      <span>{item.address.family} </span>
                      <span>{item.address.compony} </span>
                      <span>{item.address.address} </span>
                      <span>{item.address.phone} </span>
                    </p>

                    {senderOrgetter === 1 && (
                      <p className="mb-0">
                        <strong>کد پستی: </strong>
                        <span>{item.address.postCode}</span>
                      </p>
                    )}
                  </Col>

                  {senderOrgetter === 1 && (
                    <Col
                      xs="12"
                      lg={3}
                      xl={2}
                      className="d-flex justify-content-end align-items-center py-3 ps-2"
                    >
                      <button
                        className="btn btn-outline-primary"
                        onClick={() =>
                          setSelectToEditAddress({
                            id: item.address.id,
                            provinceId: item.address.provinceId,
                            cityId: item.address.cityId,
                            type: item.address.type,
                            name: item.address.name,
                            family: item.address.family,
                            nationalCode: item.address.nationalCode,
                            phone: item.address.phone,
                            tel: item.address.tel,
                            email: item.address.email,
                            compony: item.address.compony,
                            postCode: item.address.postCode,
                            address: item.address.address,
                          })
                        }
                      >
                        <span className="ms-1">ویرایش</span>
                        <PencilFill size="18" className="color-avaex" />
                      </button>
                    </Col>
                  )}
                </article>
              ))}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex align-item-center justify-content-center">
          {typeof onNewAddressClick === "function" && (
            <button
              className="text-center btn-success-style"
              onClick={onNewAddressClick}
            >
              ثبت آدرس جدید
            </button>
          )}
          <Button type="button" className="btn-cancel-style" onClick={onClose}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>

      {selectToEditAddress && (
        <EditAddress
          defaultValues={selectToEditAddress}
          onClose={() => setSelectToEditAddress(null)}
          onSubmit={() => {
            setSelectToEditAddress(null);
            mutate();
          }}
        />
      )}
    </Fragment>
  );
}
